import { z } from "zod"

const NameSchema = z.object({
  event_name: z.string().trim().min(5, 'Не менее 5 символов (пробелы по краям не считаются)'),
})

export default NameSchema